import type {
    StorageItemImageReferenceId} from "@@/shared/storage-items/storage-item-images/storage-item-image-reference-id";
import {
    storageItemImageReferenceIdFactory,
    storageItemImageReferenceIdZodSchema,
} from "@@/shared/storage-items/storage-item-images/storage-item-image-reference-id";
import { translation } from "@@/shared/translations/translation";
import type { Except } from "type-fest";
import type { ZodSchema} from "zod";
import { z } from "zod";
import { nowIsoAndUnix } from "../../date-time/iso-and-unix";
import { storageItemReferenceBaseZodObject } from "../storage-item-references/storage-item-reference-base";

const storageItemImageReferenceZodObject =
    storageItemReferenceBaseZodObject.merge(
        z.object({
            _id: storageItemImageReferenceIdZodSchema,
            type: z.literal("IMAGE"),
            blurhash: z.string().optional(),
        }),
    );
type StorageItemImageReference = z.infer<
    typeof storageItemImageReferenceZodObject
>;

const storageItemImageReferenceZodSchema: ZodSchema<StorageItemImageReference> =
    storageItemImageReferenceZodObject;

type StorageItemImageReferenceFactoryParams = Except<
    StorageItemImageReference,
    "_id" | "type" | "_type" | "_createdAt"
> & {
    _id?: StorageItemImageReferenceId;
};

const storageItemImageReferenceFactory = (
    params: StorageItemImageReferenceFactoryParams,
): StorageItemImageReference => {
    return {
        ...params,
        _id: params._id ?? storageItemImageReferenceIdFactory(),
        _type: "STORAGE_ITEM_REFERENCE",
        type: "IMAGE",
        _createdAt: nowIsoAndUnix(),
        title: params.title || translation({ sv: "Bild", en: "Image" }),
    };
};

const isStorageItemImageReference = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    storageItem: any,
): storageItem is StorageItemImageReference => {
    if (typeof storageItem === "undefined") return false;
    if (storageItem?._type !== "STORAGE_ITEM_REFERENCE") return false;
    return storageItem?.type === "IMAGE";
};

export {
    isStorageItemImageReference,
    storageItemImageReferenceFactory,
    storageItemImageReferenceZodObject,
    storageItemImageReferenceZodSchema,
};
export type { StorageItemImageReference };
